import SSPARepresentativeScreen from './SSPARepresentativeScreen.js';

export default SSPARepresentativeScreen;
